import { Link } from "react-router-dom";
import { CONTACT, LOCATION, SITE_NAME } from "../../config/location";
import { SOCIAL } from "../../config/content";
import { getSeason } from "../../config/hours";
import { ClockIcon, MapPinIcon, PhoneIcon } from "./Icons";

const FooterLabel = ({ icon, children }) => (
    <div className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-[.22em] text-messing-dunkel">
        {icon}
        {children}
    </div>
);

export default function SiteFooter() {
    const season = getSeason();

    return (
        <footer className="border-t border-forest/10 font-figtree text-forest">
            <div className="sec grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-10 pt-[72px] pb-14 text-[15px] leading-[1.7]">
                <div>
                    <img
                        src="/media/logo-frei.png"
                        alt={SITE_NAME}
                        className="-mt-3 mb-3 block h-[96px] w-auto"
                    />
                    <div className="muted">Restaurant · Terrasse · Veranstaltungen</div>
                    <div className="mt-3 flex flex-wrap gap-x-5 gap-y-1">
                        {SOCIAL.map((link) =>
                            link.url ? (
                                <a key={link.name} href={link.url} target="_blank" rel="noreferrer" className="underline">
                                    {link.name}
                                </a>
                            ) : (
                                <span key={link.name} className="muted">
                                    Platzhalter: {link.name}-Link
                                </span>
                            ),
                        )}
                    </div>
                </div>
                <div>
                    <FooterLabel icon={<MapPinIcon />}>Adresse</FooterLabel>
                    {LOCATION.venue}
                    <br />
                    {LOCATION.street}
                    <br />
                    {LOCATION.city}
                </div>
                <div>
                    <FooterLabel icon={<PhoneIcon />}>Kontakt</FooterLabel>
                    <a href={CONTACT.phoneHref} className="no-underline">
                        {CONTACT.phone}
                    </a>
                    <br />
                    <a href={`mailto:${CONTACT.email}`} className="no-underline">
                        {CONTACT.email}
                    </a>
                </div>
                <div>
                    <FooterLabel icon={<ClockIcon />}>Öffnungszeiten · {season.name}</FooterLabel>
                    {season.rows.map((row) => (
                        <div key={row.days}>
                            {row.days} {row.hours.join(" · ")}
                        </div>
                    ))}
                </div>
            </div>
            <div className="sec flex flex-wrap justify-between gap-3 border-t border-forest/10 pt-5 pb-7 text-sm text-forest/70">
                <span>© {new Date().getFullYear()} {SITE_NAME}</span>
                <div className="flex gap-6">
                    <Link to="/#gutscheine" className="no-underline">
                        Gutscheine
                    </Link>
                    <Link to="/impressum" className="no-underline">
                        Impressum
                    </Link>
                    <Link to="/datenschutz" className="no-underline">
                        Datenschutz
                    </Link>
                </div>
            </div>
        </footer>
    );
}
